export enum FilePrivacy {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}
